import React, { Component } from "react";
import Button from "@material-ui/core/Button";

import { withRouter } from "react-router";
import ArrowBackIcon from "@material-ui/icons/ArrowBack";
import ArrowForwardIcon from "@material-ui/icons/ArrowForward";
import DehazeIcon from "@material-ui/icons/Dehaze";
import SearchIcon from "@material-ui/icons/Search";
import { changeLanguage, setProduct } from "../../store/actions";
import { connect } from "react-redux";
import { Animated } from "react-animated-css";
import Logo from "../../logo.PNG";
import { CollectionsBookmarkOutlined } from "@material-ui/icons";
import InputAdornment from "@material-ui/core/InputAdornment";
import HistoryIcon from "@material-ui/icons/History";
import Input from "@material-ui/core/Input";
import { ReactComponent as ShoppingCart } from "./assets/bag.svg";
import Badge from "@material-ui/core/Badge";
import PersonIcon from "@material-ui/icons/Person";
import MenuIcon from "@material-ui/icons/Menu";
import Currency from "../Currency";
import { shouldShowProfileMenu } from "../../Helpers/orderPass";

class ProductHeader extends Component {
  state = {
    showNavBar: false,
    showBorderBottom: true,
  };

  componentDidMount = () => {
    window.addEventListener("scroll", this.handleScroll);
    this.props.homePage
      ? this.setState({ showNavBar: false, showBorderBottom: false })
      : this.setState({ showNavBar: true, showBorderBottom: true });
  };

  componentWillUnmount = () => {
    window.removeEventListener("scroll", this.handleScroll);
  };

  handleScroll = () => {
    if (this.props.homePage) {
      const rect = this.props.appRef.current.getBoundingClientRect();
      const storeInfoRect =
        this.props.storeInfoRef.current.getBoundingClientRect();
      if (storeInfoRect.y < -20) {
        this.setState({ showStoreLogoHeader: true });
      } else {
        this.setState({ showStoreLogoHeader: false });
      }
      if (rect.y < 0) {
        this.setState({ showNavBar: true, showBorderBottom: true });
      } else if (rect.y == 0) {
        this.setState({ showNavBar: false, showBorderBottom: false });
      }
    } else {
      this.setState({ showNavBar: true, showBorderBottom: true });
    }
  };

  render() {
    let ios =
      !!navigator.platform && /iPad|iPhone|iPod/.test(navigator.platform);
    let insta = navigator.userAgent.match(/instagram/i);
    insta = false;
    const { settings, isNotificationDismissed, language } = this.props;
    const showBanner =
      settings.enable_banner &&
      !this.props.isNotificationDismissed &&
      !this.props.isB2BNoticeBannerVisible;

    const goBackAndResetProduct = () => {
      if (this.props.onBack) this.props.onBack();
      else if (this.props.state) {
        this.props.history.replace(this.props.toPath, this.props.state);
      } else {
        if (
          this.props.history.length > 2 &&
          (!this.props.location.state ||
            (this.props.location.state &&
              !this.props.location.state.pending_items))
        )
          this.props.history.goBack();
        else this.props.history.replace("/");
      }
      // this.props.setProduct(null);
    };
    const totalCartLength =
      this.props.cart.cart.length + this.props.cart.promo_items.length;

    const currencyAction =
      this.props.homePage && settings.enable_currency_converter ? (
        <Button
          className={"back_arrow mt-1"}
          style={{
            float: this.props.language == "english" ? "left" : "right",
            height: "50px",
            maxWidth: "30px",
            display: "inline-block",
            zIndex: 22,
            color: "black",
            fontWeight: "bold",
            marginRight: 30,
          }}
        >
          <Currency displayText />
        </Button>
      ) : (
        <></>
      );
      const hasMenuPages =
          this.props.pages.findIndex((page) => page.placement == 1) != -1;
    const hasProfileMenu = shouldShowProfileMenu(settings, hasMenuPages);
    const backAction =
      settings.is_menu && this.props.homePage == true ? (
        <></>
      ) : (
        <>
          <Button
            className={"back_arrow mt-1"}
            //onClick={() => {
            // this.props.homePage == true
            //  ? this.props.ModalClicked()
            //   : goBackAndResetProduct();
            // }}
            onClick={() => {
              this.props.homePage == true
                ? this.props.history.push(
                   hasProfileMenu
                      ? "/profile"
                      : "/cart"
                  )
                : goBackAndResetProduct();
            }}
            style={{
              float: this.props.language == "english" ? "left" : "right",
              height: "50px",
              maxWidth: "30px",
              marginLeft: this.props.language == "english" ? "10px" : 0,
              marginRight: this.props.language == "arabic" ? "10px" : 0,
              display: "inline-block",
              zIndex: 22,
            }}
          >
            {this.props.homePage == true ? (
              <>
                {hasProfileMenu ? (
                  <MenuIcon
                    style={{
                      fill: "black",
                    }}
                  />
                ) : (
                  <>
                    <ShoppingCart
                      style={{
                        fill: "black",
                      }}
                    />
                    {totalCartLength > 0 ? (
                      <Badge
                        badgeContent={totalCartLength}
                        color="primary"
                      ></Badge>
                    ) : null}
                  </>
                )}
              </>
            ) : this.props.language == "english" ? (
              <ArrowBackIcon />
            ) : (
              <ArrowForwardIcon />
            )}
          </Button>
        </>
      );
    const languageAction = (
      <Button
        className="back_arrow mt-1 languageMakeDisappearForLargeScreen"
        onClick={() => {
          this.props.changeLanguage();
          window.scrollBy(0, 1);
          window.scrollBy(0, -1);
        }}
        style={{
          float: this.props.language == "english" ? "right" : "left",
          height: "50px",
          marginRight: this.props.language == "english" ? "10px" : 0,
          marginLeft: this.props.language == "arabic" ? "10px" : 0,
          fontSize: 20,
          paddingBottom: 15,
          color: "black",
          display: "inline",
          fontFamily: this.props.language == "arabic" && "Quicksand",
          zIndex: 22,
          fontFamily: this.props.language === "english" && "none",
        }}
      >
        {this.props.language == "english" ? "ع" : "En"}
      </Button>
    );
    const SearchAction = (
      <Button
        className=" mt-1 languageMakeDisappearForLargeScreen"
        onClick={() => {
          this.props.history.push("/search");
        }}
        style={{
          float: this.props.language == "english" ? "right" : "left",

          height: "50px",
          maxWidth: "30px",
          display: "inline-block",
          zIndex: 22,
        }}
      >
        <SearchIcon
          style={{
            color: "black",
          }}
        />
      </Button>
    );

    const historyAction =
      this.props.homePage == true && !settings.is_menu ? (
        <Button
          className=" mt-1"
          onClick={() => {
            this.props.history.push("/track/previous");
          }}
          style={{
            float: this.props.language == "english" ? "right" : "left",

            height: "50px",
            maxWidth: "30px",
            display: "inline-block",
          }}
        >
          <HistoryIcon
            style={{
              color: "black",
            }}
          />
        </Button>
      ) : null;

    const SearchBar = this.props.Search ? (
      <Input
        onBlur={(e) => {
          if (e.target) e.target.focus();
        }}
        autoFocus
        style={{
          width: "70%",
          direction: this.props.language == "english" ? "ltr" : "rtl",
        }}
        placeholder={
          this.props.language === "english" ? "Search..." : "...ابحث"
        }
        className={`my-3 ${
          this.props.language === "english" ? "float-left" : "float-right"
        }`}
        disableUnderline={true}
        defaultValue={this.props.value || ""}
        value={this.props.value}
        onChange={(e) => this.props.filter(e.target.value)}
        id="input-with-icon-textfield "
        label=""
        InputProps={{
          startAdornment: (
            <InputAdornment position="start">
              <SearchIcon />
            </InputAdornment>
          ),
        }}
      />
    ) : null;

    const showLogo =
      settings.show_logo_ar && language !== "english"
        ? settings.show_logo_ar
        : settings.show_logo;

    const showLogoUrl =
      settings.show_logo_ar && language !== "english"
        ? this.props.store.logo_ar
        : this.props.store.logo;
    const hasCoverPhoto =
      this.props.selectedCategory?.cover_photo_large ||
      this.props.selectedCategory?.cover_photo
        ? true
        : false;

    return (
      <>
        {/* {ios && insta ? (
          <div
            className={`${
              this.state.showBorderBottom ? "border-bottom " : ""
            } w-100 `.concat(
              this.props.language == "english"
                ? "detail_header"
                : "detail_header_ar"
            )}
            style={{
              height: "50px",
              backgroundColor: "white",
              zIndex: 1000,
            }}
          >
            <img
              className="img-fluid mt-1 "
              src={this.props.store.logo}
              style={{
                borderRadius: 10,
                height: 35,
                width: 35,
                objectFit: "fill",
              }}
            />
          </div>
        ) : null} */}

        <div
          className={`${
            this.state.showBorderBottom || !settings.show_cover
              ? "border-bottom "
              : ""
          } w-100 `.concat(
            this.props.language == "english"
              ? "detail_header"
              : "detail_header_ar"
          )}
          style={{
            top: this.props.filterDrawerOpen
              ? "0xp"
              : showBanner
              ? "50px"
              : "0px", /// for insta
            backgroundColor: "white",
            zIndex: 1000,
          }}
        >
          {!this.props.hideBackButton && backAction}
          {currencyAction}
          {this.props.homePage == true &&
            this.state.showStoreLogoHeader &&
            showLogo && (
              <Animated
                classNames="d-none"
                animationIn="flipInY"
                animationOut="fadeOut"
                animationInDuration={2000}
                isVisible={true}
                style={{
                  display: "inline",
                  position: "absolute",
                  width: 50,
                  right: "50%",
                  left: "43%",
                }}
              >
                <img
                  className="img-fluid mt-2"
                  src={showLogoUrl}
                  style={{
                    borderRadius: 10,
                    height: 38,
                    width: 38,
                    objectFit: "fill",
                  }}
                />
              </Animated>
            )}
          {this.props.title && !hasCoverPhoto && (
            <div
              className={"row"}
              style={{
                position: "absolute",
                width: "100%",
                left: 15,
                top: 0,
                display: "inline-block",
                lineHeight: 3.2,
              }}
            >
              <div className="col text-center">
                <p
                  style={{
                    fontWeight: 600,
                    fontSize: 17,
                    maxWidth: 187,
                    marginLeft: "auto",
                    marginRight: "auto",
                    maxHeight: 54,
                    lineHeight: 3,
                    overflow: "hidden",
                    whiteSpace: "nowrap",
                    textOverflow: "ellipsis",
                  }}
                >
                  {this.props.title}
                </p>
              </div>
            </div>
          )}
          {!this.props.Search ? (
            <>
              {" "}
              {this.props.store.settings.enable_arabic && languageAction}{" "}
              {this.props.store.settings.enable_search &&
                this.props.enableSearch &&
                SearchAction}
            </>
          ) : (
            SearchBar
          )}
          {/*  {historyAction} */}
          {hasProfileMenu
            ? this.props.homePage == true &&
              !settings.is_menu && (
                <Button
                  className=" mt-1"
                  onClick={() => {
                    this.props.history.push("/cart");
                  }}
                  style={{
                    float: this.props.language == "english" ? "right" : "left",

                    height: "50px",
                    maxWidth: "30px",
                    display: "inline-block",
                  }}
                >
                  <ShoppingCart
                    style={{
                      fill: "black",
                    }}
                  />
                  {totalCartLength > 0 ? (
                    <Badge
                      badgeContent={totalCartLength}
                      color="primary"
                    ></Badge>
                  ) : null}
                </Button>
              )
            : historyAction}
        </div>
      </>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    language: state.store.language,
    store: state.store.store,
    cart: state.cart,
    settings: state.store.store.settings,
    isNotificationDismissed: state.store.isNotificationDismissed,
    isB2BNoticeBannerVisible: state.b2b.isB2BNoticeBannerVisible,
      pages: state.staticPages.pages,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    changeLanguage: () => dispatch(changeLanguage()),
    setProduct: (prd) => dispatch(setProduct(prd)),
  };
};
export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(ProductHeader)
);
